import request from '@/utils/request'


// ===============系统管理================

//app刷新版本
export function appreload() {
    return request({
        method: 'put',
        url: "/yzdservice/api/app/version/refresh"
    })
}

//app追溯刷新版本
export function appreloadZs() {
  return request({
    method: 'put',
    url: "/yzdservice/api/app/version/refresh/2"
  })
}

//字典项刷新
export function kvreload() {
    return request({
        method: 'put',
        url: "/yzdservice/api/type/refresh"
    })
}

//化学品刷新
export function hxpreload() {
    return request({
        method: 'put',
        url: "/yzdservice/api/hxp/refresh"
    })
}

//刷新菜单缓存
export function meanreload() {
    return request({
        method: 'put',
        url: "/organization/api/resource/refreshCache"
    })
}

//刷新角色菜单缓存
export function jsreload() {
    return request({
        method: 'put',
        url: "/organization/api/roleResource/refreshCache"
    })
}

//刷新角色菜单缓存
export function jsreloaddsf() {
  return request({
    method: 'put',
    url: "/organization/api/roleResource/refreshDsfCache"
  })
}

//刷新部门缓存
export function bmreload() {
    return request({
        method: 'put',
        url: "/organization/api/dept/refreshCache"
    })
}

//刷新行政区划缓存
export function xzqhreload() {
    return request({
        method: 'put',
        url: "/organization/api/xzqh/refreshCache"
    })
}

//新闻中心缓存刷新
export function newsreload() {
    return request({
        method: 'put',
        url: "/yzdservice/api/news/refresh"
    })
}

//第三方开放平台刷新appkey
export function appkeyreload() {
    return request({
        method: 'put',
        url: "/organization/api/dsf/open/key/refresh"
    })
}
//刷新黑名单
export function refreshBackIp() {
  return request({
    method: 'put',
    url: "/authorization/api/refreshBackIp"
  })
}
//刷新接口限制
export function refreshRateLimiter() {
  return request({
    method: 'put',
    url: "/authorization/api/refreshRateLimiter"
  })
}
